import { createContext, ReactNode, useRef } from "react";

interface ContextValue {
  saveScrollPosition: (key: string, scrollTop: number) => void;
  getScrollPosition: (key: string) => number | null;
  clearScrollPosition: (key: string) => void;
  resetScrollPositions: () => void;
}

type OptionalContextValue = ContextValue | undefined;

const ScrollPositionContext = createContext<OptionalContextValue>(undefined);

interface ScrollPositionProviderProps {
  children: ReactNode;
}

const ScrollPositionProvider = ({ children }: ScrollPositionProviderProps) => {
  const scrollPositions = useRef<Map<string, number>>(new Map());

  const saveScrollPosition = (pathname: string, scrollTop: number) =>
    scrollPositions.current.set(pathname, scrollTop);

  const getScrollPosition = (key: string): number | null => {
    const scrollTop = scrollPositions.current.get(key);
    if (!scrollTop) {
      return null;
    }

    return scrollTop;
  };

  const clearScrollPosition = (key: string) =>
    scrollPositions.current.delete(key);

  const resetScrollPositions = () => scrollPositions.current.clear();

  return (
    <ScrollPositionContext.Provider
      value={{
        saveScrollPosition,
        getScrollPosition,
        clearScrollPosition,
        resetScrollPositions,
      }}
    >
      {children}
    </ScrollPositionContext.Provider>
  );
};

export { ScrollPositionContext, ScrollPositionProvider };
